<template>
    <main>
        <div class="main">
          <dl class="titleTip">
            <dt>
              <span>学术动态</span>
            </dt>
            <dd></dd>
          </dl>
            <ul class="ulBox">
                <li @click.stop="toArticleDetailsPage(item.articleId)"
                    v-for="item in articleList"
                    :key="item.articleId">
                    <div>
                        <h2>{{item.name}}</h2>
                        <span>{{item.time.split(' ')[0]}}</span>
                    </div>
                    <p>{{item.content}}</p>
                </li>
            </ul>
            <!--&lt;!&ndash; 分页器 &ndash;&gt;-->
            <!--<Pager :countNumber.sync="countNumber"-->
                   <!--:currentPage.sync="currentPage"-->
                   <!--:pagesizeList.sync="pagesizeList"-->
                   <!--:pagesize.sync="pagesize"-->
                   <!--:showPagesize="false"-->
            <!--&gt;</Pager>-->
        </div>
    </main>
</template>
<script>
    import Pager from '../../components/Pager/Pager';

    export default {
        name: 'ArticleList',
        components: {
            'Pager': Pager,
        },
        created() {
            this.getAllArticleListByLimit();
        },
        data() {
            return {
                articleList: [],
                // 分页器
                countNumber: 0,
                currentPage:1, // 当前页数
                pagesizeList: [5, 10, 20, 50, 100],
                pagesize: 5,
            }
        },
        methods: {
            getAllArticleListByLimit() {
                const start = (this.currentPage-1) * this.pagesize;
                const params = {
                    start: start,
                    limit: this.pagesize,
                };
                if (start < 0 || typeof params.start !== 'number' || typeof params.limit !== 'number') {
                    return;
                }
                this.$api.getAllArticleListByLimit(params).then(r => {
                    if (r.code === 1) {
                        this.countNumber = r.data.countNumber;
                        this.articleList = r.data.data;
                    } else {
                        console.error(r.message)
                    }
                });
            },
            toArticleDetailsPage(id) {
                this.$router.push({path: '/articlelist/article?articleId='+id})
                // let newpage = this.$router.resolve({
                //     path: '/articlelist/article?articleId='+id,
                // })
                // window.open(newpage.href, '_blank');
            },
        },
        watch: {
            currentPage() {
                this.getAllArticleListByLimit();
            },
            pagesize() {
                this.getAllArticleListByLimit();
            },
        }
    }

</script>
<style lang="scss" scoped>
    @import './ArticleList.scss';
</style>
